import React, { Suspense } from "react";
import { TaleLoadingFallback } from "@components/TaleLoadingFallback";

const AdminQuickSurveysList = React.lazy(() =>
    import("./AdminQuickSurveysList")
);

const QuickSurveyAdmin = () => {
    return (
        <Suspense fallback={<TaleLoadingFallback className="!py-20" />}>
            <AdminQuickSurveysList createPath="/admin/quick-surveys/new" />
        </Suspense>
    );
};

export default QuickSurveyAdmin;